// @flow
import JQueryView from '../../../../common/JQueryView';
import Confettiful from '../../../../common/Confettiful';

export default class IndexView extends JQueryView {
  constructor() {
    super('.main-content');
    this.confetti_perform();
  }

  confetti_perform = () => {
    window.confettiful = new Confettiful(
      document.querySelector('.main-content'),
    );
  };
}
